import { Alert, AlertIcon, Box, Button, ButtonGroup, Center, Divider, ModalBody, ModalFooter, Stack, Text, useDisclosure, useToast } from "@chakra-ui/react"
import { Clipboard, Form, Lottie, Modal, Show } from "components"
import { API } from "config"
import { useState } from "react"
import { Authenticate } from "screens"

export default function Password({ data: distributor, onSuccess = () => {}, ...props }) {
    const toast = useToast()
    const [form, setForm] = useState({})
    const [errors, setErrors] = useState()
    const [loading, setLoading] = useState(false)
    const [newPassword, setNewPassword] = useState()
    const auth = useDisclosure()

    const hasLinkedConsultant = !!distributor?.customer?.consultant?.id

    const onChange = ({ target }) => {
        const { name, value, checked } = target
        if (name === 'notify' || name === 'disconnect') setForm({ ...form, [name]: checked })
        else setForm({ ...form, [name]: value })
    }

    const handleSubmit = async () => {
        setLoading(true)
        setErrors(null)
        try {
            const callback = await API.put(`/customers/${distributor?.customer?.id}/password`, form)
            setNewPassword(callback.data?.password)
            toast({ title: 'A senha foi redefinida', description: 'Você pode copiar a senha e enviar para o responsável.' })
            setForm({})
            onSuccess()
        } catch (err) {
            setErrors(err?.response?.data?.errors)
            toast({ title: 'Não foi possível redefinir a senha.', description: err?.response?.data?.message })
        }
        setLoading(false)
    }

    return (
        <>
        <Modal loading={loading} {...props}>
            <ModalBody>
                <Lottie animation="password" height={150} options={{ loop: false }} style={{ transform: 'scale(1.8)' }} />
                <Stack spacing={6}>
                    <Center>
                        <Text fontSize="lg">Redefinir senha do núcleo</Text>
                    </Center>

                    {hasLinkedConsultant && (
                        <Alert status="warning" borderRadius="md">
                            <AlertIcon />
                            <Box>
                                <Text fontSize="sm" fontWeight="bold">Atenção: este responsável também é consultor</Text>
                                <Text fontSize="xs" mt={1}>
                                    O login é compartilhado entre o Escritório de Núcleos e o Escritório de Consultor.
                                    Ao redefinir a senha aqui, ela passará a valer nos dois sistemas automaticamente.
                                    Lembre de comunicar o responsável sobre a alteração.
                                </Text>
                            </Box>
                        </Alert>
                    )}

                    <Text fontSize="sm">
                        Ao redefinir a senha, uma nova senha de acesso é gerada e exibida aqui.
                        Você pode enviá-la ao responsável pelo e-mail cadastrado.
                    </Text>

                    <Divider />

                    <Show visible={!newPassword}>
                        <Form.Form>
                            <Form.Switch
                                label="Desconectar de todas as sessões"
                                name="disconnect"
                                isChecked={form?.disconnect}
                                isDisabled={loading}
                                onChange={onChange}
                            />
                            <Form.Switch
                                label="Enviar nova senha para o e-mail do responsável"
                                name="notify"
                                isChecked={form?.notify}
                                isDisabled={loading}
                                onChange={onChange}
                            />
                        </Form.Form>
                    </Show>

                    <Show visible={!!newPassword}>
                        <Text>Senha redefinida:</Text>
                        <Clipboard copy={newPassword}>
                            <Box w="100%" textAlign="center" py={4} bgColor="rgba(0,0,0,0.08)" borderRadius={4}>
                                <Text fontSize="2xl" fontWeight="bold">{newPassword}</Text>
                            </Box>
                        </Clipboard>
                    </Show>
                </Stack>
            </ModalBody>
            <ModalFooter>
                <ButtonGroup size="sm" isDisabled={loading}>
                    <Button isDisabled={!!newPassword} isLoading={loading} onClick={auth.onOpen}>Redefinir senha</Button>
                    <Button colorScheme="red" onClick={props.onClose}>Cancelar</Button>
                </ButtonGroup>
            </ModalFooter>
        </Modal>

        <Authenticate {...auth} onSuccess={handleSubmit} />
        </>
    )
}
